import { useEffect, useRef } from "react"

export const getCurrentUserContactId = () => (window.top as any).parent.Microsoft.Dynamic365.Portal.User.contactId
export const getCurrentUserName = () => (window.top as any).parent.Microsoft.Dynamic365.Portal.User.userName

export function usePrevious<T>(value: T) {
	const ref = useRef<T>()
	useEffect(() => {
		ref.current = value
	}, [value])
	return ref.current
}
